module.exports = __webpack_public_path__ + "static/media/SG.73f2d01a.jpg";